import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileHandlerService {
  private maxTotalSize: number = 25 * 1024 * 1024; // 25MB
  public selectedFiles: File[] = [];

  addFiles(files: FileList): { success: boolean; message?: string } {
    let newTotalSize = this.getTotalFileSizeInBytes();
    
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      
      if (this.isDuplicate(file)) {
        return { success: false, message: `El archivo "${file.name}" ya existe` };
      }
      
      newTotalSize += file.size;
      if (newTotalSize > this.maxTotalSize) {
        return { success: false, message: 'El tamaño total no puede superar 25MB' };
      }
      
      this.selectedFiles.push(file);
    }
    return { success: true };
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
  }

  getFiles(): File[] {
    return this.selectedFiles;
  }

  private isDuplicate(file: File): boolean {
    return this.selectedFiles.some(
      existing => existing.name === file.name && existing.size === file.size
    );
  }

    // Método para obtener el tamaño total de los archivos en bytes
  getTotalFileSizeInBytes(): number {
    return this.selectedFiles.reduce((total, file) => total + file.size, 0);
  }

  // Método para formatear el tamaño de un archivo
  formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  // Obtener el índice de la unidad apropiada
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  // Calcular el tamaño en la unidad apropiada
  const size = parseFloat((bytes / Math.pow(k, i)).toFixed(2));
  return `${size} ${sizes[i]}`;
}
}